var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg"},[_c('div',{staticClass:"flag1"}),_vm._v(" "),_c('div',{staticClass:"htext bu"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticClass:"flag"},[(_vm.getRegion(_vm.text).length === 2)?_c('span',{class:['flag-icon', `flag-icon-${_vm.getRegion(_vm.text)}`]}):_c('span',{class:['flag-icon']})])])
}
var staticRenderFns = []

export { render, staticRenderFns }